import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import moment from 'moment-timezone'
import { utcCurrentDate } from 'utils/helpers'
import { getDateFormat, getCurrency } from 'utils/authService'
import s from './SubscriptionUpgrade.scss'

const SubscriptionUpgrade = ({
  isConfirmPlanModalVisible,
  setIsConfirmPlanModalVisible,
  subscriptionPlan,
  setFormIsVisible
}) => {
  const getModalText = () => {
    const dueDate = moment(utcCurrentDate()).add(30, 'days').format(`${getDateFormat()}`)
    const prefix = getCurrency().symbol

    switch (subscriptionPlan) {
      case 'FREE':
        return (
          <div>
            <p>
              Your subscription will be upgraded to Small Company ({prefix}35/user/month) to allow
              for more than 1 user in your account.
            </p>
            <p>
              During the first 30 days after upgrade, you will be required to enter a valid credit
              card. The credit card won’t be charged until {dueDate} when your bill is due.
            </p>
            <p>
              If you add & remove users before the end of your billing cycle, your credit card will
              be charged for the pro-rated usage shown on the Subscription page.
            </p>
            <p>Confirm plan upgrade and continue?</p>
          </div>
        )
      case 'SMALL_COMPANY':
        return (
          <div>
            <p>
              Your subscription will be upgraded to Enterprise ({prefix}30/user/month) to allow for
              more than 10 users in your account.
            </p>
            <p>
              We will verify that the credit card on file is valid. The credit card won’t be charged
              until {dueDate} when your bill is due.
            </p>
            <p>
              If you add & remove users before the end of your billing cycle, your credit card will
              be charged for the pro-rated usage shown on the Subscription page.
            </p>
            <p>Confirm plan upgrade and continue?</p>
          </div>
        )
      default:
        return ''
    }
  }

  return (
    <Modal
      keyboard={false}
      backdrop="static"
      isOpen={isConfirmPlanModalVisible}
      toggle={() => {
        setIsConfirmPlanModalVisible(false)
      }}
      size="lg"
    >
      <ModalHeader
        toggle={() => {
          setIsConfirmPlanModalVisible(false)
        }}
        className={s.modalHeader}
      >
        Confirm Plan Upgrade
      </ModalHeader>
      <ModalBody className={s.modalBody}>
        <div className={s.content}>{getModalText()}</div>
      </ModalBody>
      <ModalFooter>
        <Button
          data-cy="save_btn"
          className={s.saveBtn}
          onClick={() => {
            setFormIsVisible(true)
            setIsConfirmPlanModalVisible(false)
          }}
        >
          Yes
        </Button>
        <Button color="secondary" onClick={() => setIsConfirmPlanModalVisible(false)}>
          No
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default SubscriptionUpgrade
